import React from "react";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { Box, Card, Divider } from "@mui/material";

// Register necessary Chart.js components and plugins
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ChartDataLabels // Registering the datalabels plugin
);

const AgentWiseSummaryReportComponent = ({ data }) => {
  // Prepare data for the chart
  const chartData = {
    labels: data?.agent_wise_summary?.map((agent) => agent.agent_details?.name), // Agent names for X-axis
    datasets: [
      {
        label: "Total Remarks",
        data: data?.agent_wise_summary?.map(
          (agent) => agent.counts?.total_remarks
        ), // Total remarks for each agent
        backgroundColor: "rgba(75, 192, 192, 0.8)", // Bar color
        borderColor: "rgba(75, 192, 192, 1)",
        borderWidth: 1,
      },
      {
        label: "Open Remarks",
        data: data?.agent_wise_summary?.map((agent) => agent.counts.open_remarks), // Open remarks for each agent
        backgroundColor: "rgba(255, 99, 132, 0.8)", // Bar color for open remarks
        borderColor: "rgba(255, 99, 132, 1)",
        borderWidth: 1,
      },
      {
        label: "Closed Remarks",
        data: data.agent_wise_summary?.map(
          (agent) => agent.counts.closed_remarks
        ), // Closed remarks for each agent
        backgroundColor: "rgba(153, 102, 255, 0.8)", // Bar color for closed remarks
        borderColor: "rgba(153, 102, 255, 1)",
        borderWidth: 1,
      },
      {
        label: "Followups",
        data: data?.agent_wise_summary?.map(
          (agent) => agent.counts.followups.total
        ), // Total followups for each agent
        backgroundColor: "rgba(255, 159, 64, 0.8)", // Bar color for followups
        borderColor: "rgba(255, 159, 64, 1)",
        borderWidth: 1,
      },
    ],
  };

  // Chart options
  const chartOptions = {
    responsive: true,
    plugins: {
      legend: {
        position: "top",
      },
      tooltip: {
        callbacks: {
          label: (tooltipItem) => {
            return `${tooltipItem.dataset.label}: ${tooltipItem.raw}`;
          },
        },
      },
      datalabels: {
        anchor: "end",
        align: "top",
        color: "#000", // Text color
        font: {
          size: 12,
          weight: "bold",
        },
        formatter: (value) => value, // Show the bar value
      },
    },
    scales: {
      x: {
        title: {
          display: true,
          text: "Agent Name",
        },
      },
      y: {
        title: {
          display: true,
          text: "Remarks / Followups",
        },
        beginAtZero: true,
      },
    },
  };

  return (
    <div>
      <Card sx={{ p: 2 }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <h4
            style={{
              fontWeight: "bold",
              fontSize: "18px",
              marginBottom: "16px",
            }}
          >
            Agent-Wise Summary
          </h4>
        </Box>
        <Divider sx={{ marginBottom: "16px" }} />

        {/* Bar Chart */}
        <Bar data={chartData} options={chartOptions} />
      </Card>
    </div>
  );
};

export default AgentWiseSummaryReportComponent;